import type { PaymentsConfigResponse } from "@townsy/contracts";
import { useBootstrapQuery, usePaymentsConfigQuery } from "../../api/queries";
import { dollarGate, type DollarGate } from "../../commerce/gates";

/** The payments gate for this visitor right now (config from `GET /payments/config`, viewer from bootstrap). */
export function useDollarGate(opts: { commercial?: boolean } = {}): DollarGate & { config: PaymentsConfigResponse | null } {
  const boot = useBootstrapQuery();
  const configQ = usePaymentsConfigQuery();
  const signedIn = Boolean(boot.data?.session.userId);
  const gate = dollarGate({
    config: configQ.data ?? null,
    configState: configQ.data ? "ready" : configQ.error ? "error" : "loading",
    viewer: { isGuest: !signedIn, emailVerified: boot.data?.session.emailVerified ?? false },
    commercial: opts.commercial,
  });
  return { ...gate, config: configQ.data ?? null };
}
